//#region src/country_code.ts
var CountryCode = /* @__PURE__ */ function(CountryCode) {
	CountryCode["Canada"] = "CA";
	CountryCode["Germany"] = "DE";
	CountryCode["UnitedKingdom"] = "GB";
	CountryCode["UnitedStates"] = "US";
	return CountryCode;
}(CountryCode || {});
//#endregion
export { CountryCode };

//# sourceMappingURL=country_code.js.map